/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var VolumeOffIcon = createIcon({
  name: 'VolumeOffIcon',
  height: 512,
  width: 257,
  svgPath: 'M216.36 71.04L127.39 160H25.33c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.47-25.96-31.98-40.97-16.98z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default VolumeOffIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/volume-off-icon.js
// module id = 1096
// module chunks = 0